import { Component, Input, OnInit } from '@angular/core';
import { NavController, App } from 'ionic-angular';
import { GlobalNotificationsProvider } from '../../providers/global-notifications/global-notifications';
import { CurrentEventProvider } from '../../providers/current-event/current-event';
import { MyEventsProvider } from '../../providers/my-events/my-events';

/**
 * Generated class for the BaseHeaderComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
    selector: 'base-header',
    templateUrl: 'base-header.html',
})
export class BaseHeaderComponent implements OnInit {
    @Input() title: string;

    event: number;
    parentEvent: number;
    eventPicture: string;

    messageIndicator: boolean;
    contactRequestIndicator: boolean;

    currentEvent: string = '';
    activeEvents: any[] = [];

    selectOptions = {
        title: 'Switch Event',
        cssClass: 'header-alert'
    };

    constructor(
        public navCtrl: NavController,
        private app: App,
        private globalNotifications: GlobalNotificationsProvider,
        public currentEventProvider: CurrentEventProvider,
        private myEventsProvider: MyEventsProvider
    ) {
        this.title = 'Match About';
    }

    ngOnInit() {
        this.globalNotifications.newMessage.subscribe(newMessage => {
            this.messageIndicator = newMessage;
        });
        this.globalNotifications.newContactRequest.subscribe(newContactRequest => {
            this.contactRequestIndicator = newContactRequest;
        });
        this.currentEventProvider.currentEvent.subscribe(
            event => {
              console.log(event)
                this.event = event.pin;
                this.parentEvent = event.parentPin;
                this.eventPicture = event.pictureUrl;
            })
    }

    openMessenger() {
        this.globalNotifications.showNewMessageIndicator(false);
        this.app.getRootNav().push('MessengerPage');
    }

    openContactRequests() {
        this.globalNotifications.showNewContactRequestIndicator(false);
        this.app.getRootNav().push('ContactRequestPage');
    }

    goToEvent(pin) {
        this.event = pin;
        const selectedEvent = this.currentEventProvider.activeEvents.find(item => item.pin === pin);
        console.log('SELECTED EVENT', selectedEvent)
        if (pin) {
            this.app.getRootNav().setRoot('EventSwitchPage', {
                pin: pin,
                name: selectedEvent && selectedEvent.name
            });
        }
    }

    backToMainEvent() {
      this.goToEvent(this.parentEvent);
    }


}



// WEBPACK FOOTER //
// ./src/components/base-header/base-header.ts